// extracted by mini-css-extract-plugin
export default {"addProductsContainer":"AddProducts_addProductsContainer__lOYPS","link":"AddProducts_link__lxuXf"};